export const FORM_ENTITIES = {
  ASSET: "Activo",
  MATERIAL: "Material",
};